import { CreditNoteOpBaseModel } from "./genericTypes";

export class CreditNoteOpUpdateModel extends CreditNoteOpBaseModel {}